// src/components/FederationLogos.js
import React from "react";
import usaplLogo from "../assets/images/logos/usapl.png";
import wrpfLogo from "../assets/images/logos/wrpf.png";
import "./FederationLogos.css";

const federations = [
  { logo: usaplLogo, name: "USA Powerlifting" },
  { logo: wrpfLogo, name: "World Raw Powerlifting Federation" },
];

const FederationLogos = () => (
  <div className="federation-logos-section">
    <div className="section-heading">
      <p className="section-heading__eyebrow">Where we compete</p>
      <h2>Federations</h2>
      <p>
        Professional meet-day handling at USAPL and WRPF competitions, from
        local meets to nationals.
      </p>
    </div>
    <ul className="logos-container">
      {federations.map((fed) => (
        <li key={fed.name} className="federation">
          <div className="federation__logo-wrap">
            <img
              src={fed.logo}
              alt={`${fed.name} logo`}
              className="federation-logo"
            />
          </div>
          <p className="federation__name">{fed.name}</p>
        </li>
      ))}
    </ul>
  </div>
);

export default FederationLogos;
